import * as React from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
function SvgLogo({
  title,
  titleId,
  ...props
}: React.SVGProps<SVGSVGElement> & SVGRProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={149}
      height={51}
      viewBox="0 0 149 51"
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <g fillRule="nonzero" fill="none">
        <path
          fill="#000"
          d="M148.4.4L130.6 34v15.7h-6.7V33.9L106.2.4h7.6l13.5 23.9 13.5-24zM92.4 22.2c.1 1 .2 1.9.2 2.9 0 7.4-4.3 14.1-11 17.2-6.5 2.8-14 1.7-19.3-2.9-6.6-6-8.3-15.8-4-23.6C63.1 7 74 3.7 82.8 8.5c.9.5 1.7 1 2.5 1.7l4.6-4.6C88.1 4.1 86.1 2.9 84 2 73.9-2.4 62 .8 55.1 9c-6.5 7.8-7.7 18.7-3.2 27.8 5.2 9.8 16.1 15.1 27 13.2 13.6-2.5 22.6-15.5 20.2-29-.3-1.4-.6-2.8-1.1-4.2l-5.6 5.4z"
        />
        <path
          d="M92.4 22.2c.1 1 .2 1.9.2 2.9 0 7.4-4.3 14.1-11 17.2-6.5 2.8-14 1.7-19.3-2.9-6.6-6-8.3-15.8-4-23.6C63.1 7 74 3.7 82.8 8.5c.9.5 1.7 1 2.5 1.7l4.6-4.6C88.1 4.1 86.1 2.9 84 2 73.9-2.4 62 .8 55.1 9c-6.5 7.8-7.7 18.7-3.2 27.8 5.2 9.8 16.1 15.1 27 13.2 13.6-2.5 22.6-15.5 20.2-29-.3-1.4-.6-2.8-1.1-4.2l-5.6 5.4z"
          fill="#000"
        />
        <path
          d="M96.6 13.2c-.8-1.6-1.8-3-2.9-4.4-.3-.4-.7-.8-1.1-1.2L75.9 24.4l-3.8-3.8-4.8 4.8 8.6 8.6 20.7-20.8z"
          fill="#EF8165"
        />
        <path
          d="M16.2 50.2C5 50.2 0 42 0 33.9h6.7c0 8.8 7.3 9.7 9.5 9.7 4.8 0 8.7-3.9 8.8-8.7V.4h6.7v33.9c.3 8.5-6.3 15.6-14.8 15.9h-.7z"
          fill="#000"
        />
      </g>
    </svg>
  );
}
export default SvgLogo;
